import { toggleCalendarLeftPaneExpansion } from '../actions/toggleCalendarLeftPaneExpansion';
import { setHasUserSetLeftNav } from '../mutators/setHasUserSetLeftNavMutator';
import { orchestrator } from 'satcheljs';

orchestrator(toggleCalendarLeftPaneExpansion, () => {
    setHasUserSetLeftNav(true);
});
